import { Container, Dialog, Grid, Tooltip, Typography } from '@material-ui/core';
import InfoIcon from '@mui/icons-material/Info';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
const HistoryViewer = ({ historyVisible, toggleHistoryVisible, data }) => {
  const [history, setHistory] = useState();
  const { t } = useTranslation();

  useEffect(() => {
    setHistory(data?.orderHistories ? data?.orderHistories : data?.statusUpdates);
  }, [data]);

  const pTooltipCreator = (status) => {
    if (status?.description?.includes('to RECEIVED')) {
      return t('orderDetails.historyViewer.inProgressPayment');
    }
    if (status?.description?.includes('to CONFIRMED')) {
      return t('orderDetails.historyViewer.successfulPayment');
    }
    if (status?.description?.includes('to PAID')) {
      return t('orderDetails.historyViewer.successfulPayment');
    }
    if (status?.description?.includes('FAIL translated to REJECTED')) {
      return t('orderDetails.historyViewer.unsuccessfulPayment');
    }
    if (status?.description?.includes('TIMEOUT translated to REJECTED')) {
      return t('orderDetails.historyViewer.timeoutPayment');
    }
    if (status?.description?.includes('to CANCELLED')) {
      return t('orderDetails.historyViewer.cancelledPayment');
    }
  };
  const oTooltipCreator = (status) => {
    if (status?.toStatus === 'PAID') {
      return t('orderDetails.historyViewer.successfulPayment');
    }
    if (status?.toStatus === 'INVOICED') {
      return t('orderDetails.historyViewer.successfulInvoice');
    }
    if (status?.toStatus === 'REJECTED_PAYMENT') {
      return t('orderDetails.historyViewer.rejectedPayment');
    }
    if (status?.toStatus === 'REJECTED_DELIVERY') {
      return t('orderDetails.historyViewer.shippingRejected');
    }
    if (status?.toStatus === 'REJECTED_INVOICE') {
      return t('orderDetails.historyViewer.invouceUnsuccessful');
    }
    if (status?.toStatus === 'SHIPPING') {
      return t('orderDetails.historyViewer.shipping');
    }
    if (status?.toStatus === 'SHIPPED') {
      return t('orderDetails.historyViewer.shipped');
    }
    if (status?.toStatus === 'DONE') {
      return t('orderDetails.historyViewer.done');
    }
  };

  return (
    <Dialog open={historyVisible} onClose={toggleHistoryVisible} maxWidth={'md'}>
      <Container spacing={3}>
        <Grid container>
          {history?.length > 0 && (
            <>
              <Grid item container xs={12} style={{ maxHeight: '90vh', backgroundColor: 'white' }}>
                {history[0]?.updateAt && (
                  <Grid container item xs={6} justifyContent='center'>
                    <Typography variant='h4'>{t('orderDetails.historyViewer.changeDate')}</Typography>
                  </Grid>
                )}
                <Grid container item xs={history[0]?.updateAt ? 6 : 12} justifyContent='center'>
                  <Typography variant='h4'>{t('orderDetails.historyViewer.changeDescription')}</Typography>
                </Grid>
              </Grid>
              {history?.map((entry, idx) => (
                <Grid
                  key={idx}
                  item
                  container
                  xs={12}
                  style={{
                    maxHeight: '90vh',
                    backgroundColor: idx % 2 ? 'lightgrey' : 'white'
                  }}>
                  {entry?.updateAt && (
                    <Grid container item xs={6}>
                      {new Date(entry.updateAt).toLocaleDateString(
                        'hu-HU',
                        {
                          hour: '2-digit',
                          minute: '2-digit',
                          seconds: '2-digit'
                        },
                        {
                          hour: '2-digit',
                          minute: '2-digit',
                          seconds: '2-digit'
                        }
                      )}
                    </Grid>
                  )}
                  <Tooltip title={entry?.message ? oTooltipCreator(entry) : pTooltipCreator(entry)} placement='bottom'>
                    <Grid container item xs={history[0]?.updateAt ? 6 : 12}>
                      {entry?.message ? entry?.message : entry?.description}
                      <InfoIcon
                        style={{
                          fontSize: '0.9rem',
                          opacity: '0.5',
                          marginLeft: '5px'
                        }}
                      />
                    </Grid>
                  </Tooltip>
                </Grid>
              ))}
              {history?.length === 0 && (
                <Grid item container xs={12} style={{ maxHeight: '90vh', backgroundColor: 'white' }}>
                  {t('orderDetails.historyViewer.selectEditorNoItems')}
                </Grid>
              )}
            </>
          )}
        </Grid>
      </Container>
    </Dialog>
  );
};

export default HistoryViewer;
